"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHomeAwayOdds(_a) {
    var odds = _a.odds, withMiddle = _a.withMiddle;
    var homeOdd = odds[0];
    var awayOdd;
    if (odds.length > 1) {
        awayOdd = odds[odds.length - 1];
    }
    var result = {
        homeOdd: homeOdd,
        awayOdd: awayOdd,
    };
    if (withMiddle) {
        result.middle = odds.slice(1, -1);
    }
    return result;
}
exports.default = getHomeAwayOdds;
//# sourceMappingURL=getHomeAwayOdds.js.map